(() => {
  const pageOnlyHeroes = {
    'fucoidan-phoenix': {
      src: 'https://cdn.shopify.com/s/files/1/0641/4558/8375/files/nyum-phoenix-pdp-hero-only.png?v=1787189674',
      stateKey: 'nyumPhoenixUserChanged',
      boundKey: 'nyumPhoenixBound'
    },
    'fucoidanforce': {
      src: 'https://cdn.shopify.com/s/files/1/0641/4558/8375/files/nyum-force-pdp-hero-only.png?v=1787191663',
      stateKey: 'nyumForceUserChanged',
      boundKey: 'nyumForceBound'
    }
  };

  const applyPageOnlyHero = (handle, config) => {
    document.querySelectorAll(`[data-nyum-product-root][data-product-handle="${handle}"]`).forEach((root) => {
      const mainImage = root.querySelector('[data-nyum-main-product-image]');
      const buttons = [...root.querySelectorAll('[data-nyum-gallery-src]')];
      const heroButton = buttons[0];
      const heroThumb = heroButton?.querySelector('img');

      if (heroButton) heroButton.dataset.nyumGallerySrc = config.src;
      if (heroThumb) {
        heroThumb.src = config.src;
        heroThumb.removeAttribute('srcset');
      }

      if (root.dataset[config.stateKey] !== 'true') {
        if (mainImage) {
          mainImage.src = config.src;
          mainImage.removeAttribute('srcset');
        }
        buttons.forEach((button) => button.classList.toggle('is-active', button === heroButton));
      }

      buttons.forEach((button) => {
        if (button.dataset[config.boundKey] === 'true') return;
        button.dataset[config.boundKey] = 'true';
        button.addEventListener('click', () => {
          root.dataset[config.stateKey] = 'true';
        }, { capture: true });
      });
    });
  };

  const applyAllPageOnlyHeroes = () => {
    Object.entries(pageOnlyHeroes).forEach(([handle, config]) => applyPageOnlyHero(handle, config));
  };

  applyAllPageOnlyHeroes();
  document.addEventListener('DOMContentLoaded', applyAllPageOnlyHeroes, { once: true });
  window.addEventListener('pageshow', applyAllPageOnlyHeroes);
  document.addEventListener('shopify:section:load', applyAllPageOnlyHeroes);
})();

(() => {
  const enhanceFucoidanMatrixLinks = () => {
    const matrix = document.querySelector('.nyum-fucoidan-matrix');
    if (!matrix) return;

    const products = [
      { selector: 'thead th:nth-child(2)', href: '/products/organic-fucoidan', label: 'Organic Fucoidan' },
      { selector: 'thead th:nth-child(3)', href: '/products/fucoidanforce', label: 'Fucoidan Force' },
      { selector: 'thead th:nth-child(4)', href: '/products/fucoidan-phoenix', label: 'Fucoidan Phoenix' }
    ];

    products.forEach(({ selector, href, label }) => {
      const cell = matrix.querySelector(selector);
      if (!cell || cell.querySelector('.nyum-fucoidan-matrix__product-link')) return;
      const name = cell.querySelector('b');
      if (!name) return;

      const link = document.createElement('a');
      link.href = href;
      link.className = 'nyum-fucoidan-matrix__product-link';
      link.textContent = name.textContent;
      link.setAttribute('aria-label', `Shop ${label}`);
      name.replaceWith(link);
    });
  };

  enhanceFucoidanMatrixLinks();
  document.addEventListener('DOMContentLoaded', enhanceFucoidanMatrixLinks, { once: true });
  window.addEventListener('pageshow', enhanceFucoidanMatrixLinks);
  document.addEventListener('shopify:section:load', enhanceFucoidanMatrixLinks);
})();
